import { render, staticRenderFns } from "./HeaderDropdown.vue?vue&type=template&id=705c56a0&"
import script from "./HeaderDropdown.vue?vue&type=script&lang=js&"
export * from "./HeaderDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports